import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React, { useRef } from 'react';
import { useStickyHeader } from './use-sticky-header';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import mergeRefs from 'react-merge-refs';
export default function InternalContainer(_a) {
    var _b, _c;
    var header = _a.header, disableHeaderPaddings = _a.disableHeaderPaddings, footer = _a.footer, children = _a.children, disableContentPaddings = _a.disableContentPaddings, __stickyHeader = _a.__stickyHeader, __stickyOffset = _a.__stickyOffset, __disableContentBorders = _a.__disableContentBorders, _d = _a.__internalRootRef, __internalRootRef = _d === void 0 ? null : _d, restProps = __rest(_a, ["header", "disableHeaderPaddings", "footer", "children", "disableContentPaddings", "__stickyHeader", "__stickyOffset", "__disableContentBorders", "__internalRootRef"]);
    var baseProps = getBaseProps(restProps);
    var rootRef = useRef(null);
    var headerRef = useRef(null);
    var _e = useStickyHeader(rootRef, headerRef, __stickyHeader, __stickyOffset), isSticky = _e.isSticky, stickyStyles = _e.stickyStyles;
    return (React.createElement("div", __assign({}, baseProps, { className: clsx(baseProps.className, styles.root, (_b = {},
            _b[styles['root-disable-content-borders']] = __disableContentBorders,
            _b)), ref: mergeRefs([rootRef, __internalRootRef]) }),
        header && (React.createElement("div", __assign({ className: clsx(styles.header, disableHeaderPaddings && styles['header-no-paddings'], isSticky && styles['header-sticky']) }, stickyStyles, { ref: headerRef }), header)),
        React.createElement("div", { className: clsx(styles.content, (_c = {},
                _c[styles['content-no-paddings']] = disableContentPaddings,
                _c[styles['content-has-header']] = header,
                _c)) }, children),
        footer && React.createElement("div", { className: styles.footer }, footer)));
}
//# sourceMappingURL=internal.js.map